import React from 'react';

type NumberingContentProps = {
  number: number;
  title: string;
  title_bold: string;
  children: React.ReactNode;
};

/**
 * @description Number 인덱스가 붙은 리스트 Item
 * @property {number} number 인덱스 Number
 * @property {string} title Item 제목
 * @property {string} title_bold Item 제목 뒷부분 (Bold)
 * @property {React.ReactNode} children Item Content
 */
function NumberingContent({
  number,
  title,
  title_bold,
  children,
}: NumberingContentProps) {
  return (
    <div className="numbering-content">
      <div className="numbering-content-title">
        <p className="text-body bold">{number}</p>
        <p className="text-body">
          {title} <br /><strong>{title_bold}</strong>
        </p>
      </div>
      <div className="numbering-content-content">{children}</div>
    </div>
  );
}

export default NumberingContent;
